<template>
  <!-- <ak-type-input hideLabel v-model="data.sales" :field="options" /> -->
  <a-month-picker v-model="data.date" @change="onChange" />
</template>

<script>
import Bus from '@/assets/js/eventBus'
export default {
  syncProps: ['value'],
  props: {
    value: null, // 当前这个字段的值，如果这个字段是虚构的，则必定是空
    field: Object, // 当前field对象
  },
  data () {
    return {
      filters: {},
      data: {
        date: ''
      }
    }
  },
  mounted () {
    Bus.$on('reset', this.reset)
    Bus.$on('resetSalary', this.reset)
  },
  beforeDestroy () {
    Bus.$off('reset', this.reset)
    Bus.$off('resetSalary', this.reset)
  },
  methods: {
    filterQuery () {
      console.log('date', this.data.date)
      if (this.data.date) {
        this._value = { $lte: this.$tkDate(this.data.date).endOf('month').toISOString(), $gte: this.$tkDate(this.data.date).startOf('month').toISOString() }
      } else {
        this._value = 'null'
      }
      // if (this._value !== null) {

      return this._value
      // }
    },
    setValue () {
      this._value = null // 不会报错
    },
    async search (filters) {
      // let res = await this.$modelAjax.get('_User', {
      //   params: {
      //     where: {
      //       adminRole: 'admin',
      //       name: filters ? {
      //         $regex: filters
      //       } : undefined
      //     }
      //   }
      // })
      // this.gdUser = res.data.results
    },
    reset (payLoad) {
      this.data.date = payLoad
    }
  },
}
</script>

<style>

</style>
